import ApiService from '@/utils/api.service'
import { API_VERSION } from '@/utils/config'

const issuers = `api/${API_VERSION}/issuers`
const pricings = `api/${API_VERSION}/pricings`

const state = {
  matrix: [],
  rules: [],
  criteria: [],
  issuers: [],
}
const getters = {
  issuersById: (state) => Object.fromEntries(state.issuers.map((issuer) => [issuer.id, issuer])),
}
const actions = {
  FETCH_MATRIX: ({ commit }) => ApiService.get(`${issuers}/pricing-capabilities`)
    .then(({ data }) => commit('SET', { key: 'matrix', value: data })),
  FETCH_RULES: ({ commit }) => ApiService.get(`${issuers}/pricing-exclusions`)
    .then(({ data }) => commit('SET', { key: 'rules', value: data })),
  FETCH_CRITERIA: ({ commit }) => ApiService.get(`${issuers}/pricing-exclusions/criteria`)
    .then(({ data }) => commit('SET', { key: 'criteria', value: data })),
  FETCH_ISSUERS: ({ commit }) => ApiService.get(`${issuers}/`)
    .then(({ data }) => commit('SET', { key: 'issuers', value: data })),
  SAVE_RULE: (_, { id, issuer_id, ...rule }) => id
    ? ApiService.put(`${issuers}/pricing-exclusions/${id}`, rule)
    : ApiService.post(`${issuers}/${issuer_id}/pricing-exclusions`, rule),
  DELETE_RULE: (_, id) => ApiService.delete(`${issuers}/pricing-exclusions/${id}`),
  // The issuer PUT is not partial: a payload without the invoice toggles resets them to false.
  SAVE_ISSUER: (_, issuer) => ApiService.put(`${issuers}/${issuer.id}`, issuer),
  FETCH_DEFAULT_CONFIG: () => ApiService.get(`${pricings}/config`, { default_config: true })
    .then(({ data }) => data),
  SAVE_DEFAULT_CONFIG: (_, config) => ApiService.put(`${pricings}/config`, config)
    .then(({ data }) => data),
  FETCH_TEAM_CONFIG: (_, teamId) => ApiService.get(`${pricings}/teams/${teamId}/pricing-config`)
    .then(({ data }) => data, (error) => {
      if (error.response?.status === 404) return null
      throw error
    }),
  SAVE_TEAM_CONFIG: (_, { teamId, config }) => ApiService.put(`${pricings}/teams/${teamId}/pricing-config`, config)
    .then(({ data }) => data),
  DELETE_TEAM_CONFIG: (_, teamId) => ApiService.delete(`${pricings}/teams/${teamId}/pricing-config`),
}
const mutations = {
  SET(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
